import { useDetailsStore, useListStore, useViewSettingsStore } from "..";
import { DetailsPanelState } from "../store/ViewSettingsStore";

export default function (): boolean {
    const listStore = useListStore();
    const detailsStore = useDetailsStore();
    const viewSettingsStore = useViewSettingsStore();

    return !!(listStore.type && detailsStore.type && viewSettingsStore.detailsPanelState === DetailsPanelState.Left);
}